<template>
  <div ref="container" class="browser-content" style="overflow: auto">
    <div v-if="content.length === 0" class="message">
      <div class="message-body">Kein text gefunden.</div>
    </div>
    <div v-for="(region, i) in content" :key="i">
      <ul v-if="region.type == 'TextRegion'">
        <li
          ref="elements"
          v-for="(element, index) in region.children"
          @click="$emit('input', element.id)"
          :key="index"
          :id="element.id"
          :class="[
            'browser-content-element',
            { 'is-highlighted': element.id === selectedElements[0] },
          ]"
        >
          <div v-if="tagMode === 'showtags' || tagMode === 'showtei'">
            <b-field v-if="tagMode === 'showtags'" group-multiline>
              <span
                v-for="(text, index) in breakWhere(
                  element.tags,
                  element.content
                )"
                :key="index"
              >
                <span v-if="searchTag(element, text)">
                  <div v-if="tagColor(element, text) == 'is-textStyle'">
                    <b-tooltip
                      position="is-right"
                      :type="tagColor(element, text)"
                      :label="toolTipLable(findTag(element, text))"
                    >
                      <span
                        :class="
                          textStyleClass(toolTipLable(findTag(element, text)))
                        "
                      >
                        {{ text }}
                      </span>
                    </b-tooltip>
                  </div>
                  <a v-else v-on:click="clickTag(element, text)">
                    &nbsp;
                    <b-tooltip
                      position="is-right"
                      :type="tagColor(element, text)"
                      :label="toolTipLable(findTag(element, text))"
                    >
                      <b-tag id="tag" :type="tagColor(element, text)">
                        {{ text }}
                      </b-tag>
                    </b-tooltip>
                  </a>
                  &nbsp;
                </span>
                <span v-else>
                  <span v-if="text.charAt(0) == ' '">
                    &nbsp;
                  </span>
                  <span
                    v-for="(segment, index) in findMatch(text)"
                    :key="index"
                    :class="[
                      'browser-content-label',
                      { 'is-highlighted': segment.isMatch },
                    ]"
                  >
                    {{ segment.string }}</span
                  >
                  <span v-if="text.slice(-1) == ' '">
                    &nbsp;
                  </span>
                </span>
              </span>
            </b-field>
            <div v-if="tagMode === 'showtei'">
              <span v-html="teiHtml(element)"> </span>
            </div>
          </div>
          <div v-else>
            <span
              v-for="(segment, index) in text"
              :key="index"
              :class="[
                'browser-content-label',
                { 'is-highlighted': segment.isMatch },
              ]"
            >
              {{ segment.string }}</span
            >
          </div>
        </li>
      </ul>
      <div v-if="region.type == 'TableRegion'">
        <table>
          <tr
            v-for="(row, index) in groupedByRow(region.children)"
            :key="index"
          >
            <td v-for="(entry, i) in row" :key="i">
              <div
                v-for="(element, k) in entry"
                @click="$emit('input', element.attributes.id)"
                ref="elements"
                :key="k"
                :id="element.id"
                :class="[
                  'browser-content-element',
                  {
                    'is-highlighted':
                      element.id && element.id === selectedElements[0],
                  },
                ]"
              >
                <div
                  v-if="
                    element.hasTag &&
                      (tagMode === 'showtags' || tagMode === 'showtei')
                  "
                >
                  <b-field v-if="tagMode === 'showtags'" group-multiline>
                    <span
                      v-for="(text, index) in breakWhere(
                        element.tags,
                        element.content
                      )"
                      :key="index"
                    >
                      <span v-if="searchTag(element, text)">
                        <div v-if="tagColor(element, text) == 'is-textStyle'">
                          <b-tooltip
                            position="is-right"
                            :type="tagColor(element, text)"
                            :label="toolTipLable(findTag(element, text))"
                          >
                            <span
                              :class="
                                textStyleClass(
                                  toolTipLable(findTag(element, text))
                                )
                              "
                            >
                              &nbsp; {{ text }} &nbsp;
                            </span>
                          </b-tooltip>
                        </div>
                        <a v-else v-on:click="clickTag(element, text)">
                          <b-tooltip
                            position="is-right"
                            :type="tagColor(element, text)"
                            :label="toolTipLable(findTag(element, text))"
                          >
                            <b-tag id="tag" :type="tagColor(element, text)">
                              {{ text }}
                            </b-tag>
                          </b-tooltip>
                        </a>
                      </span>
                      <span v-else>
                        {{ text }}
                      </span>
                    </span>
                  </b-field>
                  <div v-if="tagMode === 'showtei'">
                    <span v-html="teiHtml(element)"> </span>
                  </div>
                </div>
                <div v-else>
                  <span
                    v-for="(segment, index) in findMatch(element.content)"
                    :key="index"
                    :class="[
                      'browser-content-label',
                      { 'is-highlighted': segment.isMatch },
                    ]"
                  >
                    {{ segment.string }}</span
                  >
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<style scoped>
.is-superscript {
  position: relative;
  top: -0.5em;
  font-size: 80%;
}
.is-subscript {
  vertical-align: sub;
  font-size: smaller;
}

.is-italic {
  font-style: italic;
}

.is-underlined {
  text-decoration: underline;
}

.is-strikethrough {
  text-decoration: line-through;
}

.is-bold {
  font-weight: bold;
}
</style>
<script>
// Fix table issue like in Lite : https://transkribus.eu/r/transkribuslite-test/collection/100441/doc/595372/detail/555
// https://transkribus.eu/r/stockholm-city-archives/#/documents/595372/pages/555

import { createNamespacedHelpers } from "vuex";

var groupBy = require("json-groupby");

import DetailContentDownload from "@/components/DetailContentDownload.vue";
import { createMapper } from "@/utils/mapping.js";
const mapper = createMapper("browser");

import { findMatches } from "@/utils/matches.js";

const { mapState, mapActions, mapGetters } = createNamespacedHelpers("browser");
export default {
  props: {
    content: {
      type: [Array],
      required: true,
    },
    selected: {
      type: [Number, String],
      default: null,
    },
  },
  watch: {
    selectedElements() {
      this.scrollIntoView(this.selectedElements[0]);
    },
  },
  computed: {
    ...mapState(["selectedElements", "eventSource", "tagMode"]),
    elementIds() {
      return this.content.map((element) => element.id);
    },
    searchTerm() {
      return mapper.fromURL(this.$route.query).term;
    },
  },
  methods: {
    scrollIntoView(id) {
      var find = this.$refs.elements.find((element) => {
        if (element.id == id) {
          return element;
        }
      });
      if (!find) return;
      if (find)
        find.scrollIntoView({
          block: "center",
          inline: "center",
          behavior: "smooth",
        });
    },

    getTableAttrs(table) {
      var onlyTableCells = this.content.filter(
        (entry) => entry.type == "TableCell"
      );
      const merged = table.children.map((cell) => {
        var found = onlyTableCells.find((element) => {
          if (element.children[0]) {
            if (element.children[0].id == cell.id) {
              return element;
            }
          }
        });
        if (found) {
          cell.colAttr = found.attributes;
        }
      });
      var onlyCollAttrs = table.children.filter((entry) => entry.colAttr);
      return onlyCollAttrs;
    },
    groupedByRow(table) {
      var result = groupBy(table, ["cellAttr.row", "cellAttr.col"]);
      return result;
    },
    searchTag(element, text) {
      const found = element.tags.find(
        (x) =>
          x.length === text.length && x.offset === element.content.indexOf(text)
      );
      if (found) {
        return true;
      }
      return false;
    },
    findMatch(text) {
      if (text) {
        var terms = [];
        if (this.searchTerm) {
          terms = this.searchTerm.split(" ");
        }
        return findMatches(text, terms);
      }
    },
    findTag(element, text) {
      return element.tags.find(
        (x) =>
          x.length === text.length && x.offset === element.content.indexOf(text)
      );
    },
    textStyleClass(label) {
      var classString = "";
      if (label.includes("superscript = true")) {
        classString += "is-superscript ";
      }
      if (label.includes("subscript = true")) {
        classString += "is-subscript ";
      }
      if (label.includes("italic = true")) {
        classString += "is-italic ";
      }
      if (label.includes("underlined = true")) {
        classString += "is-underlined ";
      }
      if (label.includes("strikethrough = true")) {
        classString += "is-strikethrough ";
      }
      if (label.includes("bold = true")) {
        classString += "is-bold ";
      }
      return classString;
    },
    cleanTag(attributes) {
      var temp = JSON.parse(JSON.stringify(attributes));
      delete temp.offset;
      delete temp.length;
      var tempArr = [];
      for (let [key, value] of Object.entries(temp)) {
        tempArr.push(` ${key} = ${value} `);
      }
      return tempArr;
    },
    tagColor(element, text) {
      return (
        "is-" +
        element.tags.find(
          (x) =>
            x.length === text.length &&
            x.offset === element.content.indexOf(text)
        ).name
      );
    },
    toolTipLable(tag) {
      var cleanedAttributes = this.cleanTag(tag.attributes);
      if (cleanedAttributes.length == 0) {
        return tag.name;
      } else {
        return "" + tag.name + " | " + cleanedAttributes;
      }
    },
    teiHtml(element) {
      var text = element.content;
      var tempText = element.content;
      for (var i = 0; i < element.tags.length; i++) {
        var tag = element.tags[i];
        var tagText = text.substr(tag.attributes.offset, tag.attributes.length);
        var cleanedAttributes = this.cleanTag(tag.attributes);
        tempText = tempText.replace(
          tagText,
          '<span class ="tag is-light has-text-' +
            tag.name +
            '"> &lt' +
            tag.name +
            " " +
            cleanedAttributes +
            " &gt</span>" +
            tagText +
            '<span class="tag is-light has-text-' +
            tag.name +
            '"> &lt/ ' +
            tag.name +
            "&gt </span>"
        );
      }
      return tempText;
    },
    intoPairs: (xs) => xs.slice(1).map((x, i) => [xs[i], x]),
    breakAt(places, str) {
      return this.intoPairs([0, ...places, str.length]).map(([a, b]) =>
        str.substring(a, b)
      );
    },
    breakWhere(words, str) {
      var temp = [];
      words = words.map((x) => {
        x.offset = x.attributes.offset;
        x.length = x.attributes.length;
        temp.push({ offset: x.attributes.offset, length: x.attributes.length });
      });
      var arr = this.breakAt(
        temp
          .slice(0)
          .sort(({ offset: o1 }, { offset: o2 }) => o1 - o2)
          .reduce(
            (a, { offset, length }) => [...a, offset, offset + length],
            []
          ),
        str
      );
      arr = arr.filter((item) => item);

      return Array.from(new Set(arr));
    },
    clickTag(element, text) {
      var type = element.tags.find(
        (x) =>
          x.length === text.length && x.offset === element.content.indexOf(text)
      ).name;
      let routeData = this.$router.resolve({
        name: "Tags",
        query: { v: text, type: type },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/colors.scss";

#tag {
  margin-right: 0.25rem;
  margin-left: 0.25rem;
}

.browser-content {
  padding: 0.75rem;
  height: 100%;
}

::-moz-selection {
  background: rgba($primary, 0.125);
}

.browser-content::selection {
  background: rgba($primary, 0.125);
}

.browser-content-element {
  padding: 0.25rem 0.75rem;
}

.browser-content-element:hover {
  background-color: rgba($primary, 0.075);
}

.browser-content-element.is-highlighted {
  font-weight: bold;
  background-color: rgba($primary, 0.225);
}

.browser-content-label.is-highlighted {
  font-weight: bold;
  border-bottom: 2px solid rgba($dark-red, 0.75);
}

.browser-content-element {
  cursor: pointer;
}
</style>
